<template>
    <div id="InfoDetails">
        <div class="info-left">
            <div class="breadcrumb">
                <!--                <el-breadcrumb separator-class="el-icon-arrow-right">-->
                <!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
                <!--                    <el-breadcrumb-item @click.native="$router.go(-1)">当前资讯</el-breadcrumb-item>-->
                <!--                    <el-breadcrumb-item>当前资讯</el-breadcrumb-item>-->
                <!--                </el-breadcrumb>-->
            </div>
            <div class="info-title">
                {{infoData && infoData.title}}
            </div>
            <div class="info-subtitle">
                <span>{{infoData && infoData.addUser ? infoData.addUser : infoData.createBy}}</span>
                <span>|</span>
                <span>{{infoData && infoData.addTime ? infoData.addTime : infoData.createTime}}</span>
            </div>
            <div class="info-content" v-show="infoData.content" v-html="infoData && infoData.content"></div>
            <div class="video">
                <video controls v-show="infoData.videoUrl"
                       :src="infoData.videoUrl && infoData.videoUrl"></video>
            </div>
        </div>
        <div class="info-right">
            <!--<div class="user">-->
            <!--    <el-avatar :size="80" :src="img"></el-avatar>-->
            <!--    <div class="user-info">-->
            <!--        <div>{{infoData && infoData.addUser}}</div>-->
            <!--        <div>高级会员</div>-->
            <!--        <div>发表帖子16篇</div>-->
            <!--    </div>-->
            <!--</div>-->
            <div class="popular">
                <div class="popular-title">
                    <img src="../../assets/img/点.png" alt="">
                    <span>热门推荐</span>
                </div>
                <div class="recommend">
                    <div class="recommend-item" v-for="(item, index) of recommendList" :key="index" @click="toDetails(item)">
                        <div class="recommend-banner">
                            <img :src="item.fileUrl" alt="">
                        </div>
                        <p>{{item.title}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InfoDetails',
        data() {
            return {
                img: require('../../assets/img/logo示意.png'),
                recommendList: [
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../../assets/img/pic4.png')
                    },
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../../assets/img/pic5.png')
                    },
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../../assets/img/pic6.png')
                    }
                ],
                // 文章id
                id: '',
                infoData: '',
                type: ''
            }
        },
        methods: {
            /**
             * 获得参数
             */
            getParams() {
                this.id = this.$route.query.id
                this.type = this.$route.query.type
                this.getInfoData()
            },
            getInfoData() {
                let url = this.type === 'xuan' ? '/hdweb/portal/getPropagateInfoById' : '/hdweb/portal/getPostingById'
                this.$common.querystringifyPost(url, {
                    id: this.id
                }).then(res => {
                    console.log(res)
                    this.infoData = res.data
                })
            },
            getRecommend() {
                this.$common.querystringifyPost('/hdweb/portal/getPropagateInfoRecomm', {
                    recommend: '1',
                    pageNum: '1',
                    pageSize: '3'
                }).then(res => {
                    this.recommendList = res.data.rows
                })
            },
            toDetails(item) {
                this.$router.push({
                    path: '/InfoDetails',
                    query: {
                        id: item.id,
                        type: 'xuan'
                    }
                })
            }
        },
        created() {
            this.getParams()
            this.getRecommend()
        },
        watch: {
            '$route.query.id'(val) {
                this.getParams()
                this.getRecommend()
            }
        }
    }
</script>

<style scoped lang="less">
    #InfoDetails {
        width: 1200px;
        margin: 25px auto 0;
        display: flex;
        justify-content: space-between;
        padding-bottom: 60px;

        .info-left {
            width: 720px;

            .info-title {
                margin: 30px 0;
                font-size: 28px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .info-subtitle {
                color: rgba(153, 153, 153, 1);
                margin-bottom: 60px;
            }

            .info-content {
                width: 100%;
                line-height: 30px;
            }

            .video {
                width: 100%;

                video {
                    width: 100%;
                }
            }
        }

        .info-right {
            width: 300px;

            .user {
                width: 300px;
                height: 130px;
                border: 1px solid rgba(238, 238, 238, 1);
                display: flex;
                align-items: center;
                padding-left: 20px;
                box-sizing: border-box;

                .user-info {
                    height: 80px;
                    margin-left: 25px;

                    > div {
                        &:nth-of-type(1) {
                            font-weight: bold;
                        }

                        &:nth-of-type(2) {
                            margin-top: 5px;
                            width: 62px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            background: rgba(5, 160, 130, 0.1);
                            border: 1px solid rgba(5, 160, 130, 1);
                            border-radius: 2px;
                            color: rgba(5, 160, 130, 1);
                        }

                        &:nth-of-type(3) {
                            margin-top: 20px;
                            color: rgba(153, 153, 153, 1);
                        }
                    }
                }
            }

            .popular {
                width: 100%;
                margin-top: 25px;

                .recommend {
                    margin: 15px 0;
                    width: 100%;
                    .recommend-banner {
                        width: 100%;
                        height: 140px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        img {
                            width: 100%;
                            height: 100%;
                            transition: all .5s;
                            object-fit: cover;
                            &:hover {
                                transform: scale(1.4);
                            }
                        }
                    }

                    p {
                        margin: 10px 0 25px;
                        color: #222222;
                        height: 34px;
                        line-height: 17px;
                        overflow: hidden;
                    }
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/views/details/InfoDetails.vue